module.exports = __webpack_public_path__ + "static/media/facebook-icon.aa1dd655.svg";